<script>
    import Datepicker from 'vuejs-datepicker';

    export default {
        components: {
            'datepicker': Datepicker
        },
        name: "StepEight",
        props: {
            'course': Object,
            'offer': Object,
            'company': Object,
        },
        data() {
            return {
                refuse_payments: false,
                loading: false,
                frequencies: [
                    {id: 1, value: '1 Giorno a settimana'},
                    {id: 2, value: '2 Giorni a settimana'},
                    {id: 3, value: '3 Giorni a settimana'},
                    {id: 4, value: '4 Giorni a settimana'},
                    {id: 5, value: '5 Giorni a settimana'},
                    {id: 6, value: '6 Giorni a settimana'},
                ]
            }
        },
        mounted() {
            var self = this;

            if (this.course.lessonPackages.length < 1) {
                this.addLessonPackage();
            }

            this.$bus.$on('contracts_refused', function () {
                self.refuse_payments = true;
            });

            this.$bus.$on('contracts_accepted', function () {
                self.company.accept_payments = true;
            });

            this.course.lessonPackages.forEach(function (lessonPackage) {
                if (lessonPackage.membership_fee === null) {
                    lessonPackage.membership_fee = true;
                }
            });

            $("#lessonPackagePrice").keypress( function (evt) {
                if ((evt.which != 8) && (evt.which != 0) && (evt.which < 48 || evt.which > 57) && (evt.which != 44) && (evt.which != 46))
                {
                    evt.preventDefault();
                }
            });

        },
        methods: {
            calculateTotal(lessonPackage) {
                if (lessonPackage.membership_fee) {
                    if (this.offer.quote) {
                        return parseInt(lessonPackage.price) + parseInt(this.offer.quote);
                    } else {
                        return parseInt(lessonPackage.price);
                    }
                } else {
                    return parseInt(lessonPackage.price);
                }
            },
            acceptPaymentContracts() {
                this.$bus.$emit('ask_for_contracts');
            },
            discardPaymentContracts() {
                this.company.accept_payments = false;
            },
            togglePayments() {
                if (this.company.accept_payments) {
                    this.discardPaymentContracts()
                } else {
                    this.acceptPaymentContracts()
                }
            },
            isLoading() {
                return this.loading;
            },
            includeFee(lessonPackage) {
                lessonPackage.membership_fee = true;
            },
            excludeFee(lessonPackage) {
                lessonPackage.membership_fee = false;
            },
            isCollective(lessonPackage) {
                lessonPackage.is_collective = true;
            },
            isNotCollective(lessonPackage) {
                lessonPackage.is_collective = false;
            },
            addLessonPackage() {
                this.course.lessonPackages.push({
                    nLessons: null,
                    price: 0,
                    startDate: null,
                    endDate: null,
                    week_frequency: null,
                    membership_fee: true,
                    validationError: {
                        nLessons: false,
                        price: false,
                        startDate: false,
                        endDate: false
                    }
                })
            },
            removeLessonPackage(index) {
                this.course.lessonPackages[index].status = "deleted";
                /*this.course.lessonPackages.splice(index, 1);*/

            },
            previousStep() {
                this.$emit('update-step', 7, 8);
            },
            postForm() {
                var self = this;
                if (!this.refuse_payments && (this.company.accept_payments === null || this.company.accept_payments === 0) && !(this.offer.hasSubscription)) {
                    this.acceptPaymentContracts();
                    return;
                }

                if (this.validation()) {
                    this.loading = true;
                    this.$bus.$emit('searching');

                    axios({
                        method: 'put',
                        url: '/courses/' + self.course.courseId + '/lesson-packages',
                        data: {
                            /*lessonPackages: this.course.lessonPackages,
                            acceptPayment: this.course.accept_online_payment,*/
                            course: self.course
                        },
                    }).then((response) => {
                        self.loading = false;
                        self.$bus.$emit('filtered');

                        if (self.offer.hasSubscription) {
                            self.$emit('update-step', 9, 8);
                            return;
                        } else {
                            location.href = route('companies.dashboard.home', this.company.slug)
                        }
                    }).catch((error) => {
                        self.loading = false;
                        self.$bus.$emit('filtered');
                        self.message = 'Error';
                    });

                }
            },
            validation() {
                var validate = true;

                if (this.course.lessonPackages.length != 0) {
                    this.course.lessonPackages.forEach(function (lessonPackage) {
                        lessonPackage.validationError.nLessons = false;
                        lessonPackage.validationError.price = false;
                    })

                    this.course.lessonPackages.forEach(function (lessonPackage) {
                        if (!lessonPackage.nLessons || lessonPackage.nLessons === "") {
                            lessonPackage.validationError.nLessons = true;
                            validate = false;
                        }

                        if (!lessonPackage.price || lessonPackage.price == "") {
                            lessonPackage.validationError.price = true;
                            validate = false;
                        }
                    })
                }

                return validate;
            },

        }
    }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/course/StepEight.vue